/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPaymentDevicePresentationOrders} from '../api'

 export const useQueryGetPaymentDevicePresentationOrders = createReactQueryHook('getPaymentDevicePresentationOrders', getPaymentDevicePresentationOrders)
